
/*eslint-disable*/
import {
mapState
} from 'vuex';
import {
check,
commonApi
} from '@/common/index';
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { checkOne5, checkOne,validataEmail, ValidateRequire, validataPhone } from '@/common/utils/validate.js'
export default {
name: 'forgetPassword',
components: {
XHeader,
Tab,
TabItem,
XInput,
Group,
XButton,
PopupPicker,
},
data() {
return {
service: this.customer_service_system_link,
tabIndex: 0,
userName: '',

countriesList: [],
nowCountry: [''],

userPhone: '',
haveSendPhoneCode: true,

userEmail: '',
haveSendEmailCode: true,
}
},
computed: {
...mapState({
customer_service_system_link: state => state.FrontConfigList.customer_service_system_link,
}),
numberType() {
return this.tabIndex + 1
}
},
methods: {
onItemClick(val) { // 切换显示
this.tabIndex = val;
this.userPhone = '';
this.userEmail = '';
if (val === 2 && this.customer_service_system_link.indexOf('http') === -1) this.$router.replace({ path: '/Service' })
},
sendPhoneCode() {
if (!this.checkSendPhoneForm()) return
let params = {
username: this.userName,
numberType: this.numberType,
phoneOrEmail: this.userPhone,
};
if (this.haveSendPhoneCode) {
this.haveSendPhoneCode = false;
commonApi.USER.sendPhoneCode(params)
.then(data => {
this.haveSendPhoneCode = true;
let query = {};
query['numberType'] = 1;
query['userName'] = this.userName;
query['phoneOrEmail'] = this.userPhone;
this.$router.push({
path: '/findPassword',
query: query
})
})
.catch(err => {
this.haveSendPhoneCode = true;
this.$vux.toast.show({
text: err,
type: 'cancel'
});
})
}
},
checkSendPhoneForm() {

if (!checkOne5(this.userName)) {
this.$vux.toast.show({ text: this.$t('Forms').nameCheck, type: 'cancel' })
return
}
if (!validataPhone(this.userPhone)) { // !validataPhone(this.userPhone)
this.$vux.toast.show({ text: this.$t('Forms').phoneCheck, type: 'cancel' })
return
}
return true
},

sendEmailCode() {
if (!this.checkSendEmailForm()) return
let params = {
username: this.userName,
numberType: this.numberType,
phoneOrEmail: this.userEmail,
}
if (this.haveSendEmailCode) {
this.haveSendPhoneCode = false;
commonApi.USER.sendPhoneCode(params)
.then(data => {
this.haveSendPhoneCode = true;
let query = {};
query['numberType'] = 2;
query['userName'] = this.userName;
query['phoneOrEmail'] = this.userEmail;
this.$router.push({
path: '/findPassword',
query: query
})
})
.catch(err => {
this.haveSendPhoneCode = true;
this.$vux.toast.show({
text: err,
type: 'cancel'
});
})
}
},
checkSendEmailForm() {

if (!checkOne5(this.userName)) {
this.$vux.toast.show({ text: this.$t('Forms').nameCheck, type: 'cancel' })
return
}

if (!validataEmail(this.userEmail)) {
this.$vux.toast.show({ text: this.$t('Forms').emailCheck, type: 'cancel' })
return
}

return true
}
},
mounted() {

}
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/forgetPassword/forgetPassword.vue